import { useState } from 'react';
/**
 * Custom state hook for accessing localStorage setting for show/hide guide UI
 */
export function useGuideUI() {
    const [showGuideUI, setShowGuideUI] = useState(getGuideSettingsLocalStorage());
    const handleSetShowGuideUI = (newValue) => {
        setGuideSettingsLocalStorage(newValue);
        setShowGuideUI(newValue);
    };
    return { guideUI: showGuideUI, setGuideUI: handleSetShowGuideUI };
}
function getGuideSettingsLocalStorage() {
    const storedValue = localStorage.getItem('streemGuideUIVisible');
    if (storedValue === 'false') {
        return false;
    }
    else {
        return true;
    }
}
function setGuideSettingsLocalStorage(value) {
    localStorage.setItem('streemGuideUIVisible', value.toString());
}
//# sourceMappingURL=use_guide_ui.js.map